import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "display-element-order-bonus-tile__inner" }
const _hoisted_2 = { class: "display-element-order-bonus-tile__chosen-icon" }
const _hoisted_3 = { class: "display-element-order-bonus-tile__title" }
const _hoisted_4 = { class: "display-element-order-bonus-tile__image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "display-element-order-bonus-tile__details" }
const _hoisted_7 = { class: "display-element-order-bonus-tile__details-icon" }
const _hoisted_8 = { class: "display-element-order-bonus-tile__details-label" }
const _hoisted_9 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconSuccessCheck = _resolveComponent("IconSuccessCheck")!
  const _component_IconImagePlaceholder = _resolveComponent("IconImagePlaceholder")!
  const _component_IconTilde = _resolveComponent("IconTilde")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: _normalizeClass(["display-element-order-bonus-tile link", {
        'display-element-order-bonus-tile--embedded': _ctx.embedded,
        'display-element-order-bonus-tile--active': _ctx.active,
        'display-element-order-bonus-tile--in-cart': _ctx.inCart,
      }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
      type: "button"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_IconSuccessCheck)
        ]),
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.orderBonus.title), 1),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.showImagePlaceHolder)
            ? (_openBlock(), _createBlock(_component_IconImagePlaceholder, {
                key: 0,
                class: "display-element-order-bonus-tile__image--placeholder"
              }))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.orderBonus.imagePath,
                alt: ""
              }, null, 8, _hoisted_5))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_IconTilde, { active: _ctx.active }, null, 8, ["active"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(" Details "),
            _createElementVNode("span", _hoisted_9, " zu " + _toDisplayString(_ctx.orderBonus.title), 1)
          ])
        ])
      ])
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}